module.exports = __webpack_public_path__ + "img/zaragoza_hero_card.ec8bf09a.png";